import {Component, Input, OnInit} from '@angular/core';
import {PrintNodeOrder} from "../../../../model/PrintNodeOrder";
import {PrintNodeOrderItem} from "../../../../model/PrintNodeOrderItem";

@Component({
  selector: 'app-facility-print-node-order-item',
  templateUrl: './facility-print-node-order-item.component.html',
  styleUrls: ['./facility-print-node-order-item.component.css']
})
export class FacilityPrintNodeOrderItemComponent implements OnInit {
  @Input() printNodeOrderItem: PrintNodeOrderItem;

  constructor() { }

  ngOnInit() {
  }

}
